module.exports = __webpack_public_path__ + "img/games_widget.eea89da2.jpg";